/* eslint-disable no-useless-escape */
import { Injectable } from '@angular/core';
import { MaskitoOptions, maskitoUpdateElement } from '@maskito/core';
import {
  maskitoNumberOptionsGenerator,
  maskitoDateOptionsGenerator,
  maskitoAddOnFocusPlugin,
  maskitoRemoveOnBlurPlugin,
  maskitoEventHandler,
  maskitoCaretGuard,
} from '@maskito/kit';
import { Decimal } from 'decimal.js-light';
@Injectable({ providedIn: 'root' })
export class MaskService {
  removeMoneyMask(obj) {
    if (
      obj &&
      (typeof obj === 'string' || obj instanceof String) &&
      obj.includes('$')
    ) {
      return Number(obj.replace(/\,/gi, '').replace('$', ''));
    } else if (
      obj &&
      (typeof obj === 'string' || obj instanceof String) &&
      obj.includes('%')
    ) {
      return Number(obj.replace(/\,/gi, '').replace('%', ''));
    }
    return obj;
  }

  applyMoneyMask(obj: number): string {
    if (obj && !isNaN(parseFloat(obj.toString()))) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      }).format(obj);
    }
    return obj.toString();
  }

  removePercentMask(obj) {
    if (typeof obj === 'string' || obj instanceof String) {
      if (obj.includes('%,') || obj.includes('%, ')) {
        return +obj.replace(/%/g, '').replace(/\s/g, '').trim() / 100;
      } else {
        return (
          Number(obj.replace(/\,/gi, '').replace(/%/g, '').replace(/\s/g, '')) /
          100
        );
      }
    }
    return Number(obj) / 100;
  }

  removePercentMaskOnly(obj) {
    if (typeof obj === 'string' || obj instanceof String) {
      if (obj.includes('%,') || obj.includes('%, ')) {
        return +obj.replace(/%/g, '').replace(/\s/g, '').trim();
      } else {
        return Number(
          obj.replace(/\,/gi, '').replace(/%/g, '').replace(/\s/g, '')
        );
      }
    }
    return Number(obj);
  }

  formatPercent(num, multiply = false) {
    const inpt = new Decimal(num);
    // return Math.round( ( num + Number.EPSILON ) * 1000 ) / 100;
    if (multiply) {
      return inpt.times(100);
    } else {
      return inpt;
    }
  }

  deconstructPercent(num) {
    return (num / 1000) * 100;
  }

  dollarMaskSpecs() {
    const { plugins, ...numberOptions } = maskitoNumberOptionsGenerator({
      precision: 2,
      prefix: '$',
      thousandSeparator: ',',
    });
    const dollar: MaskitoOptions = {
      ...numberOptions,
      plugins: [
        ...plugins,
        maskitoAddOnFocusPlugin('$'),
        maskitoRemoveOnBlurPlugin('$'),
      ],
    };
    return dollar;
  }

  dollarLimitedMaskSpecs(max: number) {
    const { plugins, ...numberOptions } = maskitoNumberOptionsGenerator({
      precision: 2,
      prefix: '$',
      thousandSeparator: ',',
      max: max,
    });
    const dollar: MaskitoOptions = {
      ...numberOptions,
      plugins: [
        ...plugins,
        maskitoAddOnFocusPlugin('$'),
        maskitoRemoveOnBlurPlugin('$'),
      ],
    };
    return dollar;
  }

  percentMaskSpecs(precision = 2): MaskitoOptions {
    const { plugins, ...numberOptions } = maskitoNumberOptionsGenerator({
      precision: precision,
      postfix: '%',
      min: 0,
      max: 100,
    });
    const perc: MaskitoOptions = {
      ...numberOptions,
      plugins: [
        ...plugins,
        // Forbids caret to be placed after postfix
        maskitoCaretGuard(value => [0, value.length - 1]),
        maskitoEventHandler('focus', element => {
          if (element.value === '') {
            maskitoUpdateElement(element, `%`);
          }
        }),
        maskitoEventHandler('blur', element => {
          if (element.value === '%') {
            maskitoUpdateElement(element, ``);
          }
        }),
      ],
    };
    return perc;
  }

  Over100percentMaskSpecs(precision = 2): MaskitoOptions {
    const { plugins, ...numberOptions } = maskitoNumberOptionsGenerator({
      precision: precision,
      postfix: '%',
      min: 0,
      max: 999,
    });
    const perc: MaskitoOptions = {
      ...numberOptions,
      plugins: [
        ...plugins,
        // Forbids caret to be placed after postfix
        maskitoCaretGuard(value => [0, value.length - 1]),
        maskitoEventHandler('focus', element => {
          if (element.value === '') {
            maskitoUpdateElement(element, `%`);
          }
        }),
        maskitoEventHandler('blur', element => {
          if (element.value === '%') {
            maskitoUpdateElement(element, ``);
          }
        }),
      ],
    };
    return perc;
  }

  dateMaskSpecs(): MaskitoOptions {
    const date = maskitoDateOptionsGenerator({
      mode: 'mm/dd/yyyy',
      separator: '/',
    });
    return date;
  }
}
